AnalyticsWebClient  = require '@atlassiansox/analytics-web-client'
AnalyticsWebClientConstructor = AnalyticsWebClient.default
Auth = require 'db/auth'
Browser = require 'lib/browser'
ClientConfig = require 'debug/client-config'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'

analyticsClient = new AnalyticsWebClientConstructor
  env: AnalyticsWebClient.envType[window.analyticsWebClientEnv]
  product: 'trello',
  version: window.clientVersion,
  origin: if ClientConfig.get('appId') == 'desktop'
      AnalyticsWebClient.originType.DESKTOP
    else
      AnalyticsWebClient.originType.WEB

window.sp? 'newTracker', 'cf', window.snowplowCloudfrontServer,
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true

window.sp? 'newTracker', 'anon', window.snowplowCloudfrontServer,
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true

if Auth.isLoggedIn()
  window.sp?('setUserId:cf', Auth.myId())
  trackGoogleTagManager.push isLoggedIn: true
else
  trackGoogleTagManager.push isLoggedIn: false

if Auth.isLoggedIn() && !Browser.isEmbeddedDocument()
  analyticsClient.setTenantInfo AnalyticsWebClient.tenantType.NONE
  analyticsClient.setUserInfo AnalyticsWebClient.userType.TRELLO, Auth.myId()
  analyticsClient.startUIViewedEvent()


window.dataLayer?.push inApp: true
window.sp? ->
  trackGoogleTagManager.push
    event: 'snowplow.loaded'
    snowplow:
      domain_userid: this.cf?.getDomainUserId()



// WEBPACK FOOTER //
// ./app/scripts/init/init-analytics.coffee